import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { icons } from '../theme/icons';

interface UserMenuProps {
  currentUser: string;
  onLogout: () => void;
}

// Sits at the foot of the rail, so the menu opens up and to the right.
export function UserMenu({ currentUser, onLogout }: UserMenuProps) {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const name = currentUser || t('navigation.userMenu');

  return (
    <>
      <IconButton
        title={name}
        aria-label={name}
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{ mx: 'auto', my: 0.5 }}
      >
        <FontAwesomeIcon icon={icons.user} />
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        slotProps={{ paper: { variant: 'outlined', sx: { minWidth: '14em' } } }}
      >
        <Typography sx={{ px: 4, py: 2, fontWeight: 'medium' }}>{name}</Typography>
        <Divider />
        <MenuItem
          onClick={() => {
            setAnchor(null);
            onLogout();
          }}
        >
          <ListItemIcon>
            <FontAwesomeIcon icon={icons.signOut} />
          </ListItemIcon>
          <ListItemText primary={t('common.logout')} />
        </MenuItem>
      </Menu>
    </>
  );
}
